import React, { useMemo } from 'react'

import { useTokens, Box, Button, Typography } from '@barracuda-internal/bds-core-v2'
import { GeneralError } from '@barracuda-internal/bds-core-v2/dist/Illustrations'
import { useErrorLogic } from 'components/pages/error/useErrorLogic'

function Error() {
  const tokens = useTokens()
  const { retryUrl, onRetry } = useErrorLogic()

  return useMemo(
    () => (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          bgcolor: tokens.aliasesColorBgStaticContainerNeutral,
          height: '100%'
        }}
      >
        <Box
          sx={{
            gap: 2,
            width: '374px',
            marginTop: '100px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <GeneralError />
          <Typography variant="h1" sx={{ color: tokens.aliasesColorTextStaticEmphasis }}>
            Something went wrong
          </Typography>
          {retryUrl && (
            <Button bdsType="interactiveEmphasis" onClick={onRetry}>
              Retry
            </Button>
          )}
        </Box>
      </Box>
    ),
    [tokens, retryUrl, onRetry]
  )
}

export default Error
